import { HospitalIcon } from './HospitalIcon';

/**
 * author: Michael Irigoyen
 * id D7402851-FBF5-4861-8B6E-D141EBBDBB70
 * name hospital
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hospital.svg
 * tags
 * - Medical / Hospital 
 */
export const SwissCrossIcon = HospitalIcon;
export default SwissCrossIcon